export function chunks<T>(array: T[], size: number): T[][] {
  return Array.from(new Array(Math.ceil(array.length / size)), (_, i) => array.slice(i * size, i * size + size));
}
